import Vue from 'vue';
import api from '../../api/index';
import router from '../../router';
// const question_index_by_number = (questions, number) => {
//   const index = questions.findIndex((question) => question.number === number);
//   if (index > -1) {
//     return index;
//   } else {
//     throw new Error(`no question with number ${number}`);
//   }
// };

export default {
  namespaced: true,
  state     : {
    stats: {
      // correct_answers: [],
      // wrong_answers  : [],
      // earned_points  : 0,
    },
    questions: [
      {
        number         : 1,
        type           : 'checkbox',
        answer_accepted: false,
        answered       : false,
        points         : 1,
        question       : `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
     Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
     Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
     Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.`,
        variants: [
          {
            variant_number: 1,
            correct       : true,
            selected      : false,
            text          : 'ДВС не имеет дополнительных элементов теплопередачи — топливо само образует рабочее тело',
          },
          {
            variant_number: 2,
            correct       : false,
            selected      : false,
            text          : 'ДВС компактный, не имеет целого ряда дополнительных агрегатов',
          },
          {
            variant_number: 3,
            correct       : true,
            selected      : false,
            text          : 'Потребляет топливо, обладающее весьма жёстко заданными параметрами (испаряемостью, температурой вспышки паров, плотностью, теплотой сгорания, октановым или цетановым числом), так как от этих свойств зависит сама работоспособность ДВС',
            tooltip       : 'kek',
          },
        ],
      },
    ],
    test_history   : [],
    question_number: 0,
  },
  getters: {
    questions        : ({questions}) => questions,
    test_history     : ({test_history}) => test_history,
    stats            : ({stats}) => stats,
    points_total_test: ({questions}) => {
      let result = 0;
      questions.forEach((question) => {
        result += Number(question.points);
      });
      return result;
    },
    question_by_number      : ({questions}) => (number) => questions.find((question) => question.number === number),
    question_index_by_number: ({questions}) => (number) => questions.findIndex((question) => question.number === number),
    question_number         : ({question_number}) => question_number,
    questions_length        : ({questions}) => questions.length,
    answer_accepted         : ({answer_accepted}) => answer_accepted,
    question_answered       : ({questions}) => (number) => !!questions[number].variants.find((variant) => variant.selected),
    check_if_correct        : ({questions}) => (number) => {
      // let correct = true;
      const variants = questions[number].variants;
      const correct_variants = variants.filter((variant) => variant.correct);
      const wrong_variants = variants.filter((variant) => !variant.correct);
      let all_correct = correct_variants.every((variant) => variant.selected) && wrong_variants.every((variant) => !variant.selected);
      return all_correct;
    },
    check_question_is_last: ({questions}) => (number) => {
      const index = questions.findIndex((question) => question.number === number);
      const {length} = questions;
      return index === length - 1;
    },
    question_image: ({questions}) => (number) => {
      let result = [];
      questions[number].variants.forEach((variant) => {
        result.push(`<img src=${variant.image} alt="question" class="test__image" />`);
      });
      return result;
    },
  },
  mutations: {
    NEXT_QUESTION(state) {
      if (state.question_number < (state.questions.length - 1)) {
        return state.question_number++;
      }
    },
    PREV_QUESTION(state) {
      if (state.question_number > 0) {
        state.question_number--;
      }
    },
    ACCEPT_ANSWER(state, index) {
      state.questions[index].answer_accepted = true;
    },
    NOT_ACCEPT_ANSWER(state, index) {
      state.questions[index].answer_accepted = false;
    },
    SET_ANSWERED(state, obj) {
      let {event, question_number} = obj;
      let variants = state.questions[question_number].variants;
      let answered = false;
      // state.answer_accepted = false;
      if (state.questions[question_number].type == 'text_field') {
        answered = Boolean(event.length);
        variants[0].selected = event;
      } else if (state.questions[question_number].type == 'checkbox') {
        if (event.$event.target) {
          variants[event.variant_number].selected = event.$event.target.checked;
          for (let i = 0; i < variants.length; i++) {
            if (variants[i].selected) {
              answered = true;
            }
          }
        }
      } else if (state.questions[question_number].type == 'radio') {
        answered = true;
        variants.forEach((variant, index) => {
          variant.selected = false;
        });
        variants[event - 1].selected = true;
      }
      state.questions[state.question_number].answered = answered;
    },
    ANSWERED(state) {
      state.questions[state.question_number].answered = true;
    },
    NOT_ANSWERED(state, question) {
      if (question.type != 'text_field') {
        question.variants.forEach((variant) => {
          variant.selected = false;
        });
      } else {
        question.variants[0].selected = '';
      }
      question.answered = false;
    },
    TO_QUESTION(state, number) {
      state.question_number = number;
    },
    SET_QUESTIONS(state, questions) {
      state.questions = questions;
    },
    SET_QUESTIONS_HISTORY(state, history) {
      state.test_history = history;
      state.questions.forEach((item, index) => {
        state.test_history.forEach((answer, id) => {
          if (answer.question_id == item.id) {
            if (item.type == 'checkbox') {
              let answers = answer.answer;
              item.variants.forEach((variant, idx) => {
                if (answers.includes(String(variant.id))) {
                  variant.selected = true;
                }
              });
            } else {
              let variant = item.variants.find((variant) => {
                return variant.id == answer.answer;
              });
              variant.selected = true;
            }
          }
        });
      });
    },
    RESET_HISTORY(state) {
      state.test_history = false;
    },
  },
  actions: {
    prev_question({commit, getters, dispatch}) {
      let {question_number} = getters;

      if (question_number > 0) {
        commit('PREV_QUESTION');
      } else if (question_number == 0) {
        dispatch('testing/test_hide', {}, {root: true});
      }
    },
    async question_set_answered({getters, dispatch}, obj) {
      let {question_number, questions_length} = getters;

      if (question_number < questions_length) {
        await dispatch('check_answer', obj);
      }
    },
    next_question({commit, dispatch, getters}, answer) {
      let {question_number, questions_length} = getters;
      if (answer.answer.length != 0) {
        dispatch('question_set_answered', answer).then(() => {
          if (question_number < questions_length) {
            commit('NEXT_QUESTION');
            if (question_number == questions_length - 1) {
              dispatch('testing/killTimer', {}, {root: true});
              dispatch('testing/show_modal_results', {}, {root: true});
            }
          }
        });
      }
    },
    async check_answer({rootGetters}, obj) {
      const course_id = rootGetters['course_info/content/course_id'];
      try {
        let check = await api.course.check_answer(course_id, obj);
        return check;
      } catch (err) {
        console.error(err);
      }
    },
    reset_selected({commit, getters}) {
      let {questions, question_number} = getters;
      commit('NOT_ANSWERED', questions[question_number]);
    },
    resel_all({state, commit}) {
      state.questions.forEach((question) => {
        commit('NOT_ANSWERED', question);
      });
    },
  },
};
